import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import './EmailResults.css'
import "../FinalPage/FinalPage.css";
import { useParams } from "react-router-dom";
import "../AsmDetail/AsmDetail.css";
import bear from "../../images/f1.jpg";
import { END_URL, IMG_URL } from "../../config";
import axios from 'axios';
import ResultChart from '../ResultChart/ResultChart';
import loadimg from "../../images/loader_wish.gif";
import Subscriptions from '../Subscriptions/Subscriptions';
import ResultPageLast from '../ResultPageLast/ResultPageLast';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const Loader = () => (
  <div className="loader-overlay">
    <div className="loader-spinner"></div>
    <p>Email Sending...</p>
  </div>
);


function FinalPage({ onLoginChange }) {
  const { slug, test_slug } = useParams();
  const [dimension, setDimension] = useState(null);
  const [badge, setBadge] = useState(null);
  const [cluster, setCluster] = useState(null);
  const [test, setTest] = useState(null);
  const [existingResult, setExistingResult] = useState(null);
  const [resultDetails, setResultDetails] = useState([]);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [resultReady, setResultReady] = useState(false);

  useEffect(() => {

    FetchResultDatas();

  }, [slug, test_slug]);

  useEffect(() => {

    if (Array.isArray(resultDetails) && resultDetails.length > 0) {

      setResultReady(true);
    }
  }, [resultDetails]);

  const FetchResultDatas = async () => {
    try {
      const response = await fetch(`${END_URL}/result-clusterfinal/${slug}/${test_slug}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      setDimension(data.dimension);
      setCluster(data.cluster);
      setBadge(data.badge);
      setTest(data.test);
      setExistingResult(data.existing_result);
      setResultDetails(data.result_details);
    } catch (error) {

      console.error("Error sending result:", error);
    }
    finally {

      setIsLoading(false);
    }

  };

  const [tests, setTests] = useState([]);

  const LocalTest = JSON.parse(localStorage.getItem(slug));

  const [testData, settestData] = useState([]);

  const [Result, setResult] = useState('');

  const [Demension, setDemension] = useState([]);



  const [getBladge, setgetBladge] = useState([]);

  const token = localStorage.getItem('token');
  const [hasSubscription, setHasSubscription] = useState(false);
  const [hasplan, setHasPlan] = useState({});


  const user = localStorage.getItem('user');
  const navigate = useNavigate();

  const TestSaved = localStorage.getItem(`test_${LocalTest?.test?.id}`);


  const [Opacity, setOpacity] = useState(true);

  const [SubPlan, setSubPlan] = useState({});

  const [Subcription, setSubcription] = useState([]);

  const [TestSubcription, setTestSubcription] = useState([]);

  const [TestResut, setTestResut] = useState([]);

  const [SavedTest, setSavedTest] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [ResultLast, setResultLast] = useState(true);


  const result_letter = useMemo(() => {
    return testData?.data?.map((item) => ({
      final_letter: item.letter === 'left' ? item.leftletter : item.rightletter,
    })) || [];

    if (!testData) {
      testData = {

        test_slug: test_slug,
        slug: slug
      }
    }

  }, [testData]);



  const waitForImages = (element) => {
    const images = element.querySelectorAll('img');
    return Promise.all(
      Array.from(images).map(img => {
        if (!img.complete) {
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        }
        return Promise.resolve();
      })
    );
  };

  // const generateAndStorePDF = async () => {
  //   setIsGeneratingPDF(true);
  //   const input = document.getElementById('result-cont');
  //   if (!input) return;


  //   try {

  //     const container = document.getElementById('result-cont');
  //     if (container) {
  //       const images = container.querySelectorAll('img');
  //       Array.from(images).forEach(async img => {
  //         console.log('Image URL:', img.src);
  //         try {
  //           const response = await fetch(img.src, { method: 'HEAD' });
  //           console.log('Image accessible:', img.src, response.ok, response.status);
  //           // Check if CORS header is present
  //           const corsHeader = response.headers.get('Access-Control-Allow-Origin');
  //           console.log('CORS header:', corsHeader);

  //           return false;

  //         } catch (error) {
  //           console.error('Image fetch failed:', img.src, error);
  //         }
  //       });
  //     }

  //     // } else {
  //     //   console.error('Element with ID "container" not found.');
  //     // }



  //     await waitForImages(input);

  //     const originalScrollY = window.scrollY;
  //     const originalScrollX = window.scrollX;


  //     input.style.position = 'absolute';
  //     input.style.top = '0px';
  //     input.style.left = '0px';
  //     input.style.width = '100%';
  //     input.style.zIndex = '9999';
  //     input.style.overflow = 'visible';

  //     window.scrollTo(0, 0);


  //     const canvas = await html2canvas(input, {
  //       scale: 0.6,
  //       width: input.scrollWidth,
  //       height: input.scrollHeight,
  //       logging: false,
  //       useCORS: true,
  //       windowWidth: input.scrollWidth,
  //       windowHeight: input.scrollHeight,
  //       scrollX: 0,
  //       scrollY: 0,
  //     });


  //     input.style.position = '';
  //     input.style.top = '';
  //     input.style.left = '';
  //     input.style.width = '';
  //     input.style.zIndex = '';
  //     input.style.overflow = '';
  //     window.scrollTo(originalScrollX, originalScrollY);


  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     const imgWidth = 210;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //     const pageHeight = 297;


  //     let position = 0;
  //     while (position < canvas.height) {

  //       const sliceHeight = Math.min(
  //         canvas.height - position,
  //         (pageHeight * canvas.width) / imgWidth
  //       );


  //       const sliceCanvas = document.createElement('canvas');
  //       sliceCanvas.width = canvas.width;
  //       sliceCanvas.height = sliceHeight;
  //       const ctx = sliceCanvas.getContext('2d');
  //       ctx.drawImage(
  //         canvas,
  //         0, position,
  //         canvas.width, sliceHeight,
  //         0, 0,
  //         canvas.width, sliceHeight
  //       );


  //       const sliceImgData = sliceCanvas.toDataURL('image/jpeg', 0.7);


  //       if (position > 0) pdf.addPage();


  //       pdf.addImage(
  //         sliceImgData,
  //         'JPEG',
  //         0, 0,
  //         imgWidth, (sliceHeight * imgWidth) / canvas.width
  //       );

  //       position += sliceHeight;
  //     }


  //     const pdfBlob = pdf.output('blob');


  //     const formData = new FormData();
  //     formData.append('pdf', pdfBlob, 'result.pdf');

  //     formData.append('slug', slug);
  //     formData.append('token', token);
  //     await axios.post(`${END_URL}/store-pdf`, formData, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     });
  //     setShowSuccessModal(true);
  //   } catch (error) {
  //     console.error('PDF generation error:', error);
  //   }
  //   finally {
  //     setIsGeneratingPDF(false);
  //   }
  // };



  useEffect(() => {

    setIsLoading(true);

    if (!SavedTest) {
      settestData(LocalTest);
      setIsLoading(false);

    }

    if (SavedTest) {

      FetchUserResult().finally(() => setIsLoading(false));

    }

  }, [SavedTest,]);

  const FetchUserResult = async () => {

    try {

      const response = await fetch(`${END_URL}/user-result`, {

        method: "POST",
        headers: {

          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      const result = data?.data?.result;

      const test = {
        test: {
          id: data.test.id,
          name: data.test.name,
          type: data.test.type,
          slug: data?.test?.slug || "",
          test_slug: data?.data?.test_slug || ""
        }
      };




      const resultdata = {

        data: data?.data?.categoryresult?.map((item, index) => ({
          category_id: item.id,
          left_result: item.left_result,
          leftlabel: item.resultcategory.left_label,
          leftletter: item.resultcategory.leftletter,
          letter: item.letter,
          name: item.name,
          right_result: item.right_result,
          rightlabel: item.resultcategory.right_label,
          rightletter: item.resultcategory.rightletter,
        }))
      };

      const ConvertedtestData = {
        ...resultdata,
        result: result,
        ...test
      };

      settestData(ConvertedtestData);


      console.log(testData, 'result converted data');

    } catch (error) {

      console.error("Error sending result:", error);
    }
  };


  useEffect(() => {

    const SubcriptionDetail = async () => {

      try {

         const response = await axios.get(`${END_URL}/get-subcription`, {
              headers: {
                  Authorization: `Bearer ${token}`
              }
          });

        const reponsedata = response.data;

        setSubcription(reponsedata);



      }
      catch {
        console.log('some error ');
      }

    };

    SubcriptionDetail();
  }

    , []);


  // useEffect(() => {

  //   const checkSubscription = async () => {
  //     try {
  //       const response = await axios.post(
  //         `${END_URL}/check-subcription`,
  //         testData,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             'Content-Type': 'application/json',
  //           },
  //         }
  //       );

  //       const subscription = response.data.subcription;
  //       const plan = response.data.test_sub;

  //       setSubPlan(plan);

  //       if (subscription) {
  //         setOpacity(false);
  //       }

  //       console.log('Check subscription:', subscription);
  //       console.log('Plan received from API:', plan);
  //     } catch (error) {
  //       console.error('Error checking subscription:', error);
  //     }
  //   };

  //   if (user) {
  //     SaveTest();
  //   } else {
  //     setTimeout(() => {
  //       window.scrollTo({ top: 0, behavior: 'smooth' });
  //       onLoginChange(true);
  //     }, 5000);
  //   }

  //   checkSubscription();
  // }, [user, token]);



  useEffect(() => {
    const checkSlugSubscription = async () => {
      try {
        const response = await axios.get(`${END_URL}/subscription/check/${slug}/${test_slug}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        setHasSubscription(response.data.has_subscription);

        setHasPlan(response.data.plan);

      } catch (error) {
        setHasSubscription(false);
      }
    };

    checkSlugSubscription();
  }, [user, token]);


  useEffect(() => {

    if (Array.isArray(result_letter) && result_letter.length > 0) {

      const finalResult = result_letter.map((item) => item.final_letter).join("");

      setResult(finalResult);

    }
  }, [result_letter]);


  useEffect(() => {
    axios
      .get(`${END_URL}/tests`)
      .then((response) => {

        setTests(response.data);
      })
      .catch((error) => {
        console.error("Error fetching tests:", error);
      });
  }, []);

  const SaveTest = async () => {

    try {

      const response = await axios.post(`${END_URL}/submit/test/${slug}/${test_slug}`, LocalTest, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const testsave = response.data.saved;


      setResult(response.data.result);

      setSavedTest(testsave);


    } catch (error) {

      console.error("Error sending result:", error);
    }

  };





  useEffect(() => {

    if (Result) {

      FetchResultData(Result);
    }

  }, [Result]);

  const FetchResultData = async (finalResult) => {

    try {

      const response = await fetch(`${END_URL}/result-cluster/${slug}/${test_slug}`, {

        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({ result: finalResult }),
      });

      const data = await response.json();

      setDemension(data.dimensions);

      setCluster(data.cluster);

      setgetBladge(data.bladge);

      settestData({
        test: data.test,
        data: data.data
      });

    } catch (error) {

      console.error("Error sending result:", error);
    }
  };


  const testsubscription = testData?.test?.type;

  const typetest = testsubscription === 'free_test' ? 'type_1' : testsubscription;

  const subplan = Subcription?.data?.filter((item) => {
    return item.type === typetest;
  });

  useEffect(() => {
    if (showSuccessModal) {
      const timer = setTimeout(() => {
        window.location.href = `/final/${slug}/${test_slug}`;
      }, 2000); // 2 seconds delay
      return () => clearTimeout(timer);
    }
  }, [showSuccessModal, slug, test_slug]);





  return (

    isLoading || !resultReady ? (

      <div className="loader-container">

        <img src={loadimg} alt="Loading..." className="loader-gif" />

      </div>

    ) : (

      <>

        <div className="final-main email-pdf-div" id="result-cont">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 final-email">
                <div className="final-col-inner" >
                  {resultDetails.map((item, index) => {

                    const contentTypeClass = item.content_type ? item.content_type : "";

                    return (
                        <div className="dark-repeater final-col final-col-inner">
                      <div
                        className={`final-part1 ${contentTypeClass}`}
                        key={item.id}
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      />
                         </div>
                    );
                  })}
                </div>

              </div>

              <ResultChart
                onLoginChange={onLoginChange}
                subplan={subplan}
                token={token}
                result={result_letter}
                testdata={testData}
                demension={Demension}
                opacity={Opacity}
              />
            </div>


            {/* {testData && (
              <button
                onClick={generateAndStorePDF}
                className="btn-pdf"
                disabled={isGeneratingPDF}
              >
                {isGeneratingPDF ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span className="ms-2">Sending PDF...</span>
                  </>
                ) : (

                  <span className="nav-head-out-btn final-resul-pdf">
                    <span
                      className="nav-head-out-btn-text"
                      style={{
                        cursor: "pointer",
                        border: "none",
                        background: "none",
                        padding: 0,
                      }}
                    >
                      Send as PDF
                    </span>
                    <span className="nav-head-out-btn-icon">
                      <FontAwesomeIcon icon={faArrowRight} />
                    </span>
                  </span>
                )}
              </button>
            )} */}


          </div>

        </div>

        {showSuccessModal && (
          <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Success</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowSuccessModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  PDF sent successfully to your registered email!
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setShowSuccessModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

        )}

      </>
    )
  );

}
export default FinalPage;
